module.exports = __webpack_public_path__ + "static/media/tyre-middle.63b21767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-middle.png
// module id = 27
// module chunks = 0